import {
    useStorageAsync,
    type MaybeRefOrGetter,
    type RemovableRef,
    type UseStorageOptions,
} from '@vueuse/core';
import {capacitorStorage, preferencesStorage} from './capacitorStorage';

type DeviceStorageOptions<T> = UseStorageOptions<T> & {
    /**
     * When true (default), data is stored in the iOS Keychain / Android Keystore via
     * SecureStoragePlugin. When false, Capacitor Preferences (UserDefaults / SharedPreferences)
     * is used instead — faster on iOS because it avoids XPC calls to securityd.
     * Has no effect outside hybrid apps (localStorage is always used).
     */
    secure?: boolean;
};

export function useDeviceStorage<T>(
    key: string,
    initialValue: MaybeRefOrGetter<T>,
    options?: DeviceStorageOptions<T>
): RemovableRef<T> {
    const {secure = true, ...storageOptions} = options ?? {};
    const storage = __IS_HYBRID_APP__
        ? secure
            ? capacitorStorage
            : preferencesStorage
        : localStorage;
    return useStorageAsync(key, initialValue, storage, storageOptions) as RemovableRef<T>;
}
